import { createSlice, combineReducers } from "@reduxjs/toolkit"

// Import your slice reducers
import AppointmentReducer from "./appointment/appointmentSlice"
import ClinicReducer from "./clinic/clinicSlice"
import ConsultantReducer from "./consultant/consultantSlice"
import DoctorReducer from "./doctor/doctorSlice"
import HealthCareProfessionalReducer from "./healthCareProfessional/healthCareProfessionalSlice"
import LoginReducer from "./login/loginSlice"
import OrganisationReducer from "./organisation/organisationSlice"
import PatientReducer from "./patient/patientSlice"
import ReportReducer from "./report/reportSlice"
import RoleReducer from "./role/roleSlice"
import StatsReducer from "./stats/statsSlice"
import UserReducer from "./user/userSlice"
import WellnessVideosReducer from "./wellnessVideos/wellnessVideosSlice"
import HandoutMaterialsReducer from "./handoutMaterials/handoutMaterialsSlice"
import KeyReducer from "./key/keySlice"
import LookupsReducer from "./lookups/lookupsSlice"
import CallogsReducer from "./callogs/callogSlice"
import floatingWindowReducer from "./floatingWindow/floatingWindowSlice"
import callReducer from "./call/callSlice"
import messageCenterReducer from "./messageCenter/messageCenterSlice"
import TableDetailsReducer from "./tableDetails/tableDetailsSlice"
import playgroundReducer from "./playground/playgroundSlice"
import onboardingReducer from "./onboarding/onboardingSlice"
import billingReducer from "./billing/billingSlice"
import insuranceReducer from "./insurance/insuranceSlice"
import assessmentTemplatesReducer from "./assessmentTemplates/assessmentTemplatesSlice"

// Create a slice for the logout logic
const logoutSlice = createSlice({
    name: "logout",
    initialState: {},
    reducers: {
        userLoggedOut: () => {
            return {} // Reset the state completely
        },
    },
})

// Export the logout action
export const { userLoggedOut } = logoutSlice.actions

// Create the root reducer by combining the slice reducers
const rootReducer = (state, action) => {
    // When a logout action is dispatched, reset the entire Redux state

    return combineReducers({
        appointments: AppointmentReducer,
        clinics: ClinicReducer,
        consultant: ConsultantReducer,
        doctors: DoctorReducer,
        healthcareprofessionals: HealthCareProfessionalReducer,
        login: LoginReducer,
        organisations: OrganisationReducer,
        patients: PatientReducer,
        report: ReportReducer,
        role: RoleReducer,
        stats: StatsReducer,
        user: UserReducer,
        wellnessvideos: WellnessVideosReducer,
        key: KeyReducer,
        lookups: LookupsReducer,
        callogs: CallogsReducer,
        floatingWindow: floatingWindowReducer,
        call: callReducer,
        messageCenter: messageCenterReducer,
        tableDetails: TableDetailsReducer,
        playground: playgroundReducer,
        onboarding: onboardingReducer,
        billing: billingReducer,
        insurance: insuranceReducer,
        handoutMaterials: HandoutMaterialsReducer,
        assessmentTemplates: assessmentTemplatesReducer,
    })(state, action)
}

export default rootReducer
